import { combineReducers } from 'redux';

import deleteCustomBannerError from './deleteCustomBannerError';
import editCustomBannerError from './editCustomBannerError';
import getAffiliateToolsFilterStructureError from './getAffiliateToolsFilterStructureError';
import getAffiliateToolsError from './getAffiliateToolsError';
import getContentError from './getContentError';
import getCustomBannersError from './getCustomBannersError';
import getRotatingBannerError from './getRotatingBannerError';
import createCustomBannerError from './createCustomBannerError';


export default combineReducers({
  deleteCustomBannerError,
  editCustomBannerError,
  getAffiliateToolsError,
  getAffiliateToolsFilterStructureError,
  getContentError,
  getCustomBannersError,
  getRotatingBannerError,
  createCustomBannerError,
});
